'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCompact$002dApplication from "./presto.types$-Compact-Application.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CompactApplication$() {
}
export { $c_Lpresto_types$CompactApplication$ as $c_Lpresto_types$CompactApplication$ };
$p = $c_Lpresto_types$CompactApplication$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CompactApplication$;
/** @constructor */
function $h_Lpresto_types$CompactApplication$() {
}
export { $h_Lpresto_types$CompactApplication$ as $h_Lpresto_types$CompactApplication$ };
$h_Lpresto_types$CompactApplication$.prototype = $p;
$p.l = (function() {
  return "CompactApplication";
});
$p.ad7 = (function(x$0) {
  return new $j_presto$002etypes$0024$002dCompact$002dApplication.$c_Lpresto_types$CompactApplication($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), x$0.j(2), x$0.j(3));
});
var $d_Lpresto_types$CompactApplication$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CompactApplication$, "presto.types$CompactApplication$", ({
  YH: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$CompactApplication$ as $d_Lpresto_types$CompactApplication$ };
var $n_Lpresto_types$CompactApplication$;
function $m_Lpresto_types$CompactApplication$() {
  if ((!$n_Lpresto_types$CompactApplication$)) {
    $n_Lpresto_types$CompactApplication$ = new $c_Lpresto_types$CompactApplication$();
  }
  return $n_Lpresto_types$CompactApplication$;
}
export { $m_Lpresto_types$CompactApplication$ as $m_Lpresto_types$CompactApplication$ };
//# sourceMappingURL=presto.types$-Compact-Application$.js.map
